export default __webpack_public_path__ + "static/media/Buffarini.bee73c52.jpg";